// eslint-disable-next-line import/prefer-default-export
export const renderTableColumns = (t) => [
  {
    title: t('paymentScheduleTable.date'),
    property: 'date',
    sortable: false,
  },
  {
    title: t('paymentScheduleTable.email'),
    property: 'email',
    sortable: false,
  },
  {
    title: t('paymentScheduleTable.amount'),
    property: 'amount',
    sortable: false,
  },
  {
    title: t('paymentScheduleTable.contractId'),
    property: 'masysId',
    sortable: false,
  },
];
